import { createContext } from 'react';

export const TimeseriesChartIdContext = createContext<string | undefined>(
  undefined,
);
